import { styled } from '@mui/system';
import { Button, ListItemText, Select, Typography } from '@mui/material';
import ReactCodeInput from 'react-code-input';

const AskDataTypography = styled(Typography)({
  marginBottom: '8px',
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#414046',
  textAlign: 'left',
});

const IconListItemText = styled(ListItemText)({
  fontSize: '32px',
  marginRight: '10px',
  maxWidth: '16px',
});

const InlinePhoneContainer = styled('div')({
  display: 'inline-block',
  marginRight: '5px',
});

const CenterCodeInput = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '4px',
});

const CodeInput = styled(ReactCodeInput)((prop) => ({
  input: {
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'center',
    justifyContent: 'center',
    fontFamily: 'Poppins',
    margin: '4px 3px',
    width: '38px',
    borderRadius: '4px',
    fontSize: '20px',
    lineHeight: '23px',
    height: '50px',
    backgroundColor: '#FFFFFF',
    color: '#414046 !important',
    border: prop.isValid ? 'grey solid 1px' : '0.8px solid red !important',
    '&:focus': {
      border: '1px solid #0A7ABE !important',
      outline: '#c8c8c8 solid 1px',
    },
    '&:nth-child(1)': {
      order: '1 !important',
    },
    '&:nth-child(2)': {
      order: '2 !important',
    },
    '&:nth-child(3)': {
      order: '3 !important',
    },
    '&:nth-child(4)': {
      order: '5 !important',
    },
    '&:nth-child(5)': {
      order: '6 !important',
    },
    '&:nth-child(6)': {
      order: '7 !important',
    },
    '&:nth-child(7)': {
      order: '8 !important',
      display: 'none !important',
    },
  },
  display: 'flex !important',
  alignItems: 'center !important',
  justifyContent: 'center !important',
  '&::after': {
    content: '""',
    margin: '0px 0px !important',
    width: '15px !important',
    height: '3px !important',
    backgroundColor: 'withe !important',
    order: '4 !important',
  },
}));

const CodeHelperContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  width: 'fit-content',
  margin: '0 auto',
});
interface DisableProps {
  disabled?: boolean;
}
const CodeHelperButton = styled(Button)<DisableProps>(({ disabled }) => ({
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '16px',
  textAlign: 'center',
  letterSpacing: '0.15px',
  textDecoration: 'none',
  color: disabled ? '#AFAFAF' : '#0A7ABE',
  textTransform: 'none',
}));

const IncorrectCodeTypography = styled(Typography)({
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: 'red',
  textAlign: 'center',
  minHeight: '24px',
});

const LoaderComponentContainer = styled('div')({
  position: 'absolute',
  top: '40vh',
  left: 'calc(50vw - 150px)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
  height: '20vh',
  paddingTop: '5vh',
  paddingBottom: '5vh',
  width: 300,
  borderRadius: '10px',
  backgroundColor: '#FFFFFF',
  zIndex: 4002,
});

const GreyOverlay = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 4001,
});

const CheckContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '0px',
  alignItems: 'center',
  justifyContent: 'center',
  justifyItems: 'center',
});

export {
  AskDataTypography,
  CenterCodeInput,
  CheckContainer,
  CodeInput,
  GreyOverlay,
  IconListItemText,
  IncorrectCodeTypography,
  InlinePhoneContainer,
  LoaderComponentContainer,
  CodeHelperButton,
  CodeHelperContainer,
};
